import EmObject from '@ember/object';
import Route from 'cio/routes/base';

export default class IndexLoadingRoute extends Route {
  templateName = 'segments.index';
  controllerName = 'segments.index';

  setupController(controller) {
    controller.set('model', new Array(5).fill(EmObject.create()));
  }
}
